<template>
    <div class="ui-location">
        <span v-for="(txt, index) in menuList" :key="index">{{ txt }}</span>
    </div>
</template>

<script>
export default {
    name: 'breadcrumb',
    props: {
        location: Array,
    },
    data() {
        return {
            menuList: [],
        };
    },
    watch: {
        $route: {
            immediate: true, // 컴포넌트가 생성될 때도 실행
            handler(to) {
                this.updateMenuList(to);
            },
        },
    },
    methods: {
        updateMenuList(route) {
            this.menuList = route.meta.gnbMenu || [];
        },
    },
};
</script>
<style lang="scss" scoped></style>
